"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipInsurerMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
let OpportunityPlacementSlipInsurerMap = class OpportunityPlacementSlipInsurerMap {
};
exports.OpportunityPlacementSlipInsurerMap = OpportunityPlacementSlipInsurerMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_location_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "insurerLocationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_branch_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "insurerBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_contact_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "insurerContactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipInsurerMap.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPlacementSlipInsurerMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPlacementSlipInsurerMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placement) => placement.insurerMaps),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration !== "undefined" && opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration) === "function" ? _c : Object)
], OpportunityPlacementSlipInsurerMap.prototype, "placementSlip", void 0);
exports.OpportunityPlacementSlipInsurerMap = OpportunityPlacementSlipInsurerMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_insurer_map")
], OpportunityPlacementSlipInsurerMap);
